export default __webpack_public_path__ + "screen.png?c04539dcce476d43ee77966a92c88c33";